(function () {
	var TARGET = 'https://vgr.store';
	var KEEP = ['/cart', '/checkouts', '/account', '/orders', '/apps', '/password', '/.well-known', '/admin', '/a/', '/tools', '/services', '/wallets'];
	var path = location.pathname;
	var params = new URLSearchParams(location.search);

	if (window.Shopify && window.Shopify.designMode) return;
	if (params.has('preview_theme_id') || params.has('_fd') || params.has('pb')) return;
	if (KEEP.some(function (p) { return path === p || path.indexOf(p === '/a/' ? p : p + '/') === 0; })) return;

	var dest = path;
	if (path.indexOf('/products/') === 0) dest = '/product/' + path.slice('/products/'.length);
	else if (path.indexOf('/pages/') === 0) dest = '/';

	location.replace(TARGET + dest + location.search + location.hash);
})();
